import { XmlMapping, XmlType } from '../models/xml';

export function mapXmlFields<T>(fields: any[], mapping: XmlMapping[]): T[] {
  return fields.map((field) => mapXmlField(field, mapping));
}

export function mapXmlField<T>(field: any, mapping: XmlMapping[]): T {
  const result: any = {};
  mapping.forEach((mapping) => {
    if (mapping.type == XmlType.Array) {
      let array = field;
      const xmlParts = mapping.xml.split('.');
      xmlParts.forEach((xml, index) => (array = index === xmlParts.length - 1 ? array[xml] : array[xml]?.[0]));
      result[mapping.field] = array?.map((ar) => mapXmlFields([ar], mapping.mappings)[0]);
    } else if (mapping.type == XmlType.Object) {
      result[mapping.field] = mapXmlField(field[mapping.xml]?.[0], mapping.mappings);
    } else {
      result[mapping.field] = mapXmlType(field[mapping.xml]?.[0]?.trim(), mapping.type);
    }
  });
  return result;
}

function mapXmlType(value: string, mappingType: XmlType): string | number | boolean {
  switch (mappingType) {
    case XmlType.String:
      return value;
    case XmlType.Number:
      return +value;
    case XmlType.Boolean:
      return value === 'true';
    case XmlType.Date:
      return value;
  }
}
